import React, { Component } from 'react';
import PerfectScrollbar from 'perfect-scrollbar';
import $ from "jquery";

class StepOne extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            ack: {
                Achternaam: this.props.data.ack.Achternaam,
                Voorletters: this.props.data.ack.Voorletters,
                Voornaam: this.props.data.ack.Voornaam,
                Adres: this.props.data.ack.Adres,
                Postcode: this.props.data.ack.Postcode,
                Woonplaats: this.props.data.ack.Woonplaats,
                Telefoon: this.props.data.ack.Telefoon,
                Email: this.props.data.ack.Email,
                Opmerking: this.props.data.ack.Opmerking,
            }
        }
    }
    
    componentDidMount = () => {
        this.height();
        const ps = new PerfectScrollbar('.stepFour', {
            wheelSpeed: 2,
            wheelPropagation: true,
            minScrollbarLength: 20
        });
        this.setState((prevState) => {
            prevState.ps = ps;
            return prevState;
        });
        $(window).off();
        $(window).on("resize", this.resize.bind(this)); 
    }

    componentDidUpdate = () => {
        this.height();
        this.state.ps.update();
    }

    resize = () => {
        this.height();
        this.state.ps.update();
    }

    height = () => {    
        let totalHeight = $(window).outerHeight();
        totalHeight = (totalHeight > 900) ? 900 : totalHeight;
        let heightHeader = $(".header").outerHeight();
        let heightSteps = $(".steps").outerHeight();
        let heightPagination = $(".pagination-btns").outerHeight();

        let occupied = 
          heightHeader //header
        + heightSteps //steps
        + heightPagination //pagination
        - 5;
        
        let available = totalHeight - occupied + "px";
        document.querySelector(".stepFour").style.height = available;     
    }

    isSexChecked = (sex) => {
        return this.props.data.sex === sex;
    }

    handleChange = (e, name) => {
        this.setState((prevState) => {
            prevState.ack[name] = e.target.value;
            return prevState;
        }, () => {
            this.props.setAck(this.state.ack);
        });
    }

    render() {
        return (
            <div className="columns" style={{width: "100%"}}>
                <div className="column">
                    <div className="stepFour">
                        <div className="field mb-4">
                            <input className="is-checkradio is-danger" id="ack_heer" type="radio" name="ack_title" defaultChecked={this.isSexChecked("Man")} />
                            <label htmlFor="ack_heer">Heer</label>
                            <input className="is-checkradio is-danger" id="ack_mevrouw" type="radio" name="ack_title" defaultChecked={this.isSexChecked("Vrouw")} />
                            <label htmlFor="ack_mevrouw">Mevrouw</label>
                        </div>
                        <div className="cField">
                            <div className="cLabel">
                                Achternaam
                            </div>
                            <div className="cControl">
                                <input value={this.state.ack.Achternaam} onChange={(e) => this.handleChange(e, "Achternaam")} className="input cInput" type="text" placeholder="verplicht" />
                            </div>
                        </div>
                        <div className="cField">
                            <div className="cLabel">
                                Voorletters
                            </div>
                            <div className="cControl">
                                <input value={this.state.ack.Voorletters} onChange={(e) => this.handleChange(e, "Voorletters")} className="input cInput" type="text" />
                            </div>
                        </div>
                        <div className="cField">
                            <div className="cLabel">
                                Voornaam
                            </div>
                            <div className="cControl">
                                <input value={this.state.ack.Voornaam} onChange={(e) => this.handleChange(e, "Voornaam")} className="input cInput" type="text" placeholder="verplicht" />
                            </div>
                        </div>
                        <div className="cField">
                            <div className="cLabel">
                                Adres
                            </div>
                            <div className="cControl">
                                <input value={this.state.ack.Adres} onChange={(e) => this.handleChange(e, "Adres")}  className="input cInput" type="text" placeholder="verplicht" />
                            </div>
                        </div>
                        <div className="cField">
                            <div className="cLabel">
                                Postcode
                            </div>
                            <div className="cControl">
                                <input value={this.state.ack.Postcode} onChange={(e) => this.handleChange(e, "Postcode")}  className="input cInput" type="text" placeholder="verplicht" />
                            </div>
                        </div>
                        <div className="cField">
                            <div className="cLabel">
                                Woonplaats
                            </div>
                            <div className="cControl">
                                <input value={this.state.ack.Woonplaats} onChange={(e) => this.handleChange(e, "Woonplaats")} className="input cInput" type="text" placeholder="verplicht" />
                            </div>
                        </div>
                        <div className="cField">
                            <div className="cLabel">
                                Telefoon
                            </div>
                            <div className="cControl">
                                <input value={this.state.ack.Telefoon} onChange={(e) => this.handleChange(e, "Telefoon")} className="input cInput" type="text" placeholder="verplicht" />
                            </div>
                        </div>
                        <div className="cField">
                            <div className="cLabel">
                                Email
                            </div>
                            <div className="cControl">
                                <input value={this.state.ack.Email} onChange={(e) => this.handleChange(e, "Email")} className="input cInput" type="text" placeholder="verplicht" />
                            </div>
                        </div>
                        <div className="cField">
                            <div className="cLabel">
                                Opmerking
                            </div>
                            <div className="cControl">
                                <textarea value={this.state.ack.Opmerking} onChange={(e) => this.handleChange(e, "Opmerking")} className="textarea cInput" type="text" maxLength="200" ></textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default StepOne;